import Vue from 'vue'
import App from './App.vue'
import router from './router'
import VueRout from 'vue-router'
import { Loading } from 'element-ui'
Vue.config.productionTip = false
Vue.use(VueRout)
Vue.use(Loading.directive);
new Vue({
  render: h => h(App),
  router: router
}).$mount('#app')
router.beforeEach((to, from, next) => {    
  // chrome
  document.body.scrollTop = 0
  // firefox
  document.documentElement.scrollTop = 0
  // safari
  window.pageYOffset = 0
  next()
})